/**
 * Adapta el `query` que genera el mixin de tablas al contrato del listado de
 * balanceadores (`/shipment.balancing.api/client-groups/pagination`).
 *
 * El mixin inyecta siempre un `created_at.between` con la ventana del selector
 * de fechas, pero en este endpoint el `query` solo sirve para filtrar *que
 * balanceadores* salen (nombre, activo, orden). Mandar ahi la fecha filtra por
 * fecha de creacion y esconde todos los balanceadores creados fuera del rango,
 * que es justo lo contrario de lo que quiere un panel de rendimiento.
 *
 * La ventana de los stats viaja aparte, en los params `stats_from`/`stats_to`.
 */

export const DATE_FIELD = "created_at";

/**
 * Las columnas de contadores usan claves sinteticas (`stats_leads_in`) porque
 * CCTable no resuelve claves anidadas. Al ordenar, el mixin mete esa clave tal
 * cual en el `order`, pero el endpoint solo conoce el campo real de `stats`.
 */
export const SORT_PREFIX = "stats_";

export function adapterBalancerGroupsQuery(query = {}) {
    const next = { ...(query || {}) };

    if (next.order) {
        const order = {};
        for (const field in next.order) {
            const target = field.startsWith(SORT_PREFIX)
                ? field.slice(SORT_PREFIX.length)
                : field;
            order[target] = next.order[field];
        }
        next.order = order;
    }

    if (!next.where) {
        return next;
    }

    const where = { ...next.where };
    delete where[DATE_FIELD];

    if (Object.keys(where).length > 0) {
        next.where = where;
    } else {
        delete next.where;
    }

    return next;
}
